{{!-- Shown in a companion's file cell while its pending product-page upload is being attached.
      renderCart rebuilds the cell from cart state once the attach lands. --}}
<div class="orderItem-files-uploading" aria-live="polite">
    <span class="orderItem-files-uploading-spinner" aria-hidden="true"></span>
    Attaching file&hellip;
</div>
